import { EntityType } from '@exam-management/graphql';

import type { QSetReviewTaskDetailsFormInput } from '../schemas';
import type { SubtaskDetails } from '../types';

import isAddedSubtaskKey from './is-add-subtask-key';

export default function mapQSetReviewSetSubtaskDetailsFormData(
  subtaskDetails: SubtaskDetails[],
  subtaskFormData: QSetReviewTaskDetailsFormInput['subtask'],
) {
  return Object.entries(subtaskFormData).map(([formSubtaskCode, formData]) => {
    const baseSubtaskData = {
      assigneeId: formData.assignee.value,
      dueDate: formData.dueDate,
      entityType: EntityType.Qset,
      entityId: formData.qSetId,
    };
    const subtaskData = subtaskDetails.find((subtask) => subtask.code === formSubtaskCode);
    if (subtaskData?.id && !isAddedSubtaskKey(formSubtaskCode)) {
      return { id: subtaskData.id, ...baseSubtaskData };
    } else {
      return baseSubtaskData;
    }
  });
}
